var c = this;
// cache dos perfis de usuarios
var userProfiles = [];

var cryo_maskphone = "(99) 99999-9999";
var cryo_mask_cep = "99999-999";

var formAction;

if (!Date.prototype.toISOString) {
    (function () {
        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        Date.prototype.toISOString = function () {
            return this.getUTCFullYear() +
                '-' + pad(this.getUTCMonth() + 1) +
                '-' + pad(this.getUTCDate()) +
                'T' + pad(this.getUTCHours()) +
                ':' + pad(this.getUTCMinutes()) +
                ':' + pad(this.getUTCSeconds()) +
                '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
                'Z';
        };
    }());
}

function getObj(n) {
    return document.getElementById(n);
}

$(document).ready(function () {
    cryo_setNavbarTargetOnColorbox();
    cryo_setColorbox();

    if ($.fn.typeahead)
        $.extend($.fn.typeahead.defaults, {
            item: '<li><a href="#" style="padding-right: 50px"></a></li>',
            highlighter: function (item) {
                var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');

                var $item = $("<div/>").html(item);

                if ($item.children().length > 0)
                    return item;

                $item.find(":not(iframe)")
                    .addBack()
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3;
                    })
                    .each(function () {
                        this.parentNode.innerHTML = this.parentNode.innerHTML.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
                            return '<strong>' + match + '</strong>';
                        });
                    });

                return $item.prop("outerHTML");
            }
        });
});

function cryo_setColorbox() {
    $.colorbox.settings.opacity = 0.6;
    $.colorbox.settings.transition = "none";
    $.colorbox.settings.trapFocus = false;
    //$("#cboxContent").addClass("blue_border_example");
    $("#cboxTopLeft").remove();
    $("#cboxTopRight").remove();
    $("#cboxTopCenter").remove();
    $("#cboxBottomCenter").remove();
    $("#cboxBottomLeft").remove();
    $("#cboxBottomRight").remove();
    $("#cboxMiddleRight").remove();
    $("#cboxMiddleLeft").remove();

    $('*').on('click', '[data-colorbox="true"]', function () {
        var $a = $(this);
        var url = '';
        if ($a.attr('querystring') == null)
            url = $a.attr("href");
        else
            url = $a.attr('querystring');

        var w = $a.attr("data-colorbox-width") || "90%";
        var h = $a.attr("data-colorbox-height") || "90%";
        $.colorbox();
        $.colorbox({ href: url, iframe: true, innerWidth: w, innerHeight: h });
        return false;
    });
}

function cryo_confirm(message, title, primaryButtonLabel, okcallback, closeColorbox) {
    if (closeColorbox === undefined) {
        closeColorbox = true;
    }
    const html =
        `<div class="cryo-confirm-dialog">
            <div class="modal-header"><h3>${title}</h3></div>
            <div class="modal-body">${message}</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link ${(clientIsMobile ? 'btn-large' : '')}" accesskey="${mlLblNoAccessKey}">
                    ${btnCancel} <sup class="shortcut">${mlLblNoAccessKey}</sup>
                </button>
                <button type="button" class="btn btn-primary ${(clientIsMobile ? 'btn-large' : '')}" accesskey="${mlLblYesAccessKey}">
                    ${primaryButtonLabel} <sup class="shortcut">${mlLblYesAccessKey}</sup>
                </button>
            </div>
        </div>`;
    $.colorbox({ closeButton: false, width: (clientIsMobile ? "90%" : "500px"), html: html });
    cryo_UnderlineAccessKey('div.cryo-confirm-dialog', true);
    $(".cryo-confirm-dialog").find(".btn-primary").focus();
    $(".cryo-confirm-dialog").find(".btn-primary").click(function () { if (closeColorbox) { $.colorbox.close(); } okcallback(); });
    $(".cryo-confirm-dialog").find(".btn-link").click(function () { $.colorbox.close(); });
}

function cryo_alert(msg, okcallback) {
    msg = msg.replace(/\n/g, '<br>');
    $.colorbox({ closeButton: false, width: (clientIsMobile ? "90%" : "400px"), html: '<div class="cryo-confirm-dialog padded"><h2>' + mlLblAtention + '!</h2><p>' + msg + '</p><div class="spaced text-right"><button type="button" class="btn btn-success ' + (clientIsMobile ? 'btn-large' : '') + '">OK</button></div></div>' });
    cryo_UnderlineAccessKey('div.cryo-confirm-dialog');
    $(".cryo-confirm-dialog").find(".btn-success").focus();
    $(".cryo-confirm-dialog").find(".btn-success").click(function () { $.colorbox.close(); if (okcallback != null && okcallback != undefined) okcallback(); });
}

function cryo_configTargetPostbackLogout(link) {
    $("form").attr("target", "");
    $("form").attr("action", "");
    cryo_configTargetPostback(link);
}

function cryo_configTargetPostback(link) {
    try {
        if (self != top) {
            if (parent.document) {
                $(link).attr("target", "");
                $("form").attr("target", "_parent");
            }
        }
    } catch (e) {
    }
}
function cryo_setNavbarTargetOnColorbox() {
    if (self != top) {
        $(".navbar a").attr("target", "_parent");
    }
}

var cryo_searchuser_cod, cryo_searchuser_text;
function cryo_setSearchUser(cod, text) {
    cryo_searchuser_cod = cod;
    cryo_searchuser_text = text;
    function _openUserSearch() {
        $.colorbox({ href: URL_ROOT + 'workflow/wffinduser.aspx?inpSearch=' + text.val(), iframe: true, innerWidth: 500, innerHeight: 300 });
    }
    text.addClass("search");

    text.keyup(function (e) {
        var code = e.keyCode || e.which;
        if (!(code == 8 || code == 46)) {//not backspace or delete
            _openUserSearch();
        }
    });
    text.change(function () {
        if ($(this).val() == "") {
            cod.val("");
        }
    });
    text.parent().find("a").click(function () {
        _openUserSearch();
    });
}
function cryo_searchUserCallBack(cod, text) {
    cryo_searchuser_cod.val(cod);
    cryo_searchuser_text.val(text);
}

function cryo_cryptPass(p) {
    $("#inpToCrypt").val(1);
}

function cryo_Upload(folder, comment, requester) {
    if (comment == null) comment = "0";
    if (requester == null) requester = "0";
    $.colorbox({ href: URL_ROOT + 'workbase/wupload.aspx?inpDsFolder=' + folder + "&inpShowComment=" + comment + "&inpShowRequesterCheck=" + requester, iframe: true, innerWidth: "90%", innerHeight: "80%" });
}

function cryo_UploadCrypt(c) {
    $.colorbox({ href: URL_ROOT + 'workbase/wupload.aspx?c=' + c, iframe: true, innerWidth: "90%", innerHeight: "90%", scrolling: true });
}

function cryo_getTopFrame(init) {
    if (init == null) init = self;
    var found = false;
    var frame = init;
    if (frame != null && frame != top) {
        try {
            while (!found) {
                if (frame != top
                    && frame.parent != null
                    && frame.parent.document != null
                    && frame.location != frame.parent.location) {
                    frame = frame.parent;
                } else {
                    found = true;
                }
            }
        } catch (e) { found = true; }
    }
    return frame;
}

function cryo_pop(url, e) {
    if (e != null) {
        e.returnValue = false;
        e.cancel = true;
    }
    if (typeof url === 'object') url = $(url).attr("data-href") != "" ? $(url).attr("data-href") : $(url).attr("href");
    if (e != null) e = e || window.event;
    var frame = cryo_getTopFrame();
    if ((
        (e == null || !e.ctrlKey)
        && (url.toLowerCase().indexOf('wfflow_execute.aspx') >= 0
            || url.toLowerCase().indexOf('/task') >= 0
            || url.toLowerCase().indexOf('/request') >= 0
            || url.toLowerCase().indexOf('wfrel_tracker_detail.aspx') >= 0
            || url.toLowerCase().indexOf('/audit') >= 0
            || url.toLowerCase().indexOf('readonly.aspx') >= 0)
        && frame == top
    )
    ) {
        frame.$('#cboxLoadingGraphic').show();
        frame.$.colorbox({
            href: url,
            iframe: true,
            innerWidth: (clientIsMobile ? "99%" : "90%"),
            innerHeight: (clientIsMobile ? "96%" : "90%"),
            fastIframe: false,
            onComplete: function () {
                frame.$("body").css("overflow-y", "hidden");
                frame.$(".default").css("margin-right", "17px");
            },
            onClosed: function () {
                frame.$("body").css("overflow-y", "scroll");
                frame.$(".default").css("margin-right", "0px");
            }
        });
    } else {
        window.open(url);
    }
    return false;
}

function closeBpmModal() {
    if (!cryo_isInIframe()) {
        window.self.close();
    } else {
        var element = new parent.Modal(parent.document.getElementById('dynmodal'))
        element.hide();
    }
}

function cryo_popClose(cod) {
    if (!cryo_isInIframe()) {
        window.self.close();
    } else if (parent) {
        try {
            parent.$.colorbox.close();
        } catch (e) {
            window.self.close();
        }
    } else {
        window.self.close();
    }
}

function cryo_isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function cryo_searchUser(o, u) {
    $.colorbox({ href: URL_ROOT + 'workflow/wffinduser.aspx', iframe: true, innerWidth: 700, innerHeight: 400 });
}

function cryo_configTypehead(name, cod, activeonly, forceallusers, onSelectCallback, clearIfNoneFound) {
    if (activeonly == null) activeonly = false;
    if (forceallusers == null) forceallusers = false;
    $('#' + name)
        .attr('autocomplete', 'off')
        .blur(function () {
            if ($('#' + cod).val() == "")
                $(this).val("");

            if ($(this).val() == "")
                $('#' + cod).val("");
        })
        .typeahead(
            {
                minLength: 3,
                source: function source(query, process) {
                    $('ul.typeahead').css('z-index', '9999');
                    $.ajax({
                        url: URL_ROOT + 'api/internal/legacy/1.0/user/usernames.aspx',
                        dataType: 'json',
                        async: true,
                        data: 'includeCode=1&forceAllUsers=' + (forceallusers ? '1' : '0') + '&activeOnly=' + (activeonly ? "1" : "0") + '&inpDsName=*' + query + '*&photo=1',
                        success: function (data) {
                            arrNames = [];
                            arrCodesAndName = [];

                            if (data.success !== undefined) {
                                var noPhoto = URL_ROOT + 'common/images/v3/member.jpg';
                                var template = "";
                                if (!clientIsMobile) {
                                    template = '<div class="user user-small" data-id="{{id}}"><div class="user-photo" style="background-image: url({{img}})"><img src="{{img}}"></div><div class="user-content"><strong class="inline">{{name}}</strong><div class="muted"><span class="hide">{{username}} </span>{{email}}</div></div></div>';
                                } else {
                                    template = '<div class="user" data-id="{{id}}">{{name}}</div>';
                                }
                                $.each(data.success, function (i, o) {
                                    var item = template;

                                    item = item.replace(/\{\{id\}\}/gi, o.CodUser);
                                    if (o.DsPhoto !== '') {
                                        item = item.replace(/\{\{img\}\}/gi, o.DsPhoto);
                                    } else {
                                        item = item.replace(/\{\{img\}\}/gi, noPhoto);
                                    }
                                    item = item.replace('{{name}}', o.DsName);
                                    item = item.replace('{{username}}', o.DsUserName);
                                    item = item.replace('{{email}}', o.DsEmail);

                                    arrNames.push(item);

                                    arrCodesAndName.push({ "code": o.CodUser, "name": o.DsName });
                                });
                            } else {
                                $.each(data, function (i, o) {
                                    var code, name;
                                    if (o.indexOf('___') > -1) {
                                        var info = o.split('___');
                                        name = info[0];
                                        code = info[1];
                                        arrNames.push(name);
                                        arrCodesAndName.push({ "code": code, "name": name });
                                    }
                                });
                            }

                            if (clearIfNoneFound) {
                                $('#' + cod).val("");
                            }

                            process(arrNames);
                        }
                    });
                },
                matcher: function (item) {
                    return true
                },
                updater: function (data) {
                    if (data !== undefined) {
                        if (data.indexOf('<') > -1) {
                            // com foto

                            var dataToHtml = $.parseHTML(data);

                            var div = $(dataToHtml);
                            var code = $(div).attr('data-id');

                            $('#' + cod).val(code);

                            $.each(arrCodesAndName, function (i, o) {
                                if (o.code == code) {
                                    data = o.name.replace(/<(?:.|\n)*?>/gm, '');
                                    $('#' + cod).val(o.code);

                                    if (onSelectCallback !== undefined) {
                                        onSelectCallback();
                                    }
                                }
                            });
                        } else {
                            $.each(arrCodesAndName, function (i, o) {
                                if (o.name == data) {
                                    data = data.replace(/<(?:.|\n)*?>/gm, '');
                                    $('#' + cod).val(o.code);

                                    if (onSelectCallback !== undefined) {
                                        onSelectCallback();
                                    }
                                }
                            });
                        }
                    }
                    return data;
                }
            });
}

function cryo_camelcase(s) {
    s = $.trim(s);

    s = ((/\S[A-Z]/.test(s)) ?
        s.replace(/(.)([A-Z])/g, function (t, a, b) { return a + ' ' + b.toLowerCase(); }) :
        s.replace(/( )([a-z])/g, function (t, a, b) { return b.toUpperCase(); }));

    // remover espacos se ainda houver e retornar
    s = s.replace(/\s+/g, '');

    s = s.substring(0, 1).toLowerCase() + s.substring(1);

    return s;
}

function cryo_url(s) {
    s = $.trim(s);

    s = ((/\S[A-Z]/.test(s)) ?
        s.replace(/(.)([A-Z])/g, function (t, a, b) { return a + '-' + b }) :
        s.replace(/( )([a-z])/g, function (t, a, b) { return '-' + b }));

    // remover espacos se ainda houver e retornar
    s = s.replace(/\s+/g, '-');

    s = s.substring(0, 1).toLowerCase() + s.substring(1);

    return s;
}

function cryo_resizeIFrame(frame, offset) {
    try {
        if (offset == null) offset = 0;

        if (frame != null && frame.document != null) {
            var w = frame.document.body.scrollWidth;
            var h = frame.document.body.scrollHeight;
            //frame.height = h + 100;

            if (frame.document.body.scrollWidth > frame.document.body.offsetWidth) {
                document.getElementById(frame.name).height = h + offset;
                frame.height = h + offset;
            }
            else {
                document.getElementById(frame.name).height = h + offset;
            }
        }
    } catch (ex) { }
}

// retorna valor de propriedade do objeto
// obj - referencia do objeto
// propertyName - nome da propriedade
function cryo_GetObjectPropertyValue(obj, propertyName) {
    if (!obj.attributes) return null;
    if (obj && propertyName) {
        if (window.attachEvent) {
            // IE
            if (obj.getAttribute(propertyName) != null) {
                return obj.getAttribute(propertyName);
            } else {
                return "";
            }
        } else {
            return obj.getAttribute(propertyName);
        }
    }
    return "";
}

function cryo_SetObjectPropertyValue(obj, propertyName, propertyValue) {
    // se objeto nao possui atributos entao retorna null
    if (!obj.attributes) return null;

    // se objeto e propriedade existem
    if (obj && propertyName) {
        obj.setAttribute(propertyName, propertyValue);
    } else {
        return null;
    }
}

function cryo_search(s, c) {
    var url = URL_ROOT + 'report/main?';

    if (s !== undefined) {
        url = url + 'inpsearch=' + s;
    }
    if (c !== undefined && c !== '') {
        url = url + '&c=' + c;
    }

    location.href = url;
    event.returnValue = false;
    event.cancel = true;
}

function cryo_writeCookie(name, value) {
    var expires = new Date(2500, 12, 31);
    parent.document.cookie = name + "=" + escape(value) + "; expires=" + expires.toGMTString();
}

function cryo_readCookie(name) {
    var query = name + "=";
    var frame = cryo_getTopFrame();
    if (frame.document.cookie.length > 0) { // se existir cookies
        offset = frame.document.cookie.indexOf(query);
        if (offset != -1) { // se existe cookie
            offset += query.length;
            // index = comeco do valor
            end = frame.document.cookie.indexOf(";", offset);
            // index = fim do valor
            if (end == -1) {
                end = frame.document.cookie.length;
            }
            return unescape(frame.document.cookie.substring(offset, end));
        }
    }
}

function cryo_mdc(o) {
    if (!o.length)
        return 0;
    for (var r, a, i = o.length - 1, b = o[i]; i;)
        for (a = o[--i]; r = a % b; a = b, b = r);
    return b;
}

function cryo_getAspectRatio() {
    var mdc = cryo_mdc([screen.width, screen.height]);

    return (screen.width / mdc) + ":" + (screen.height / mdc);
}

// 29/04/2022 - Tiago Silva - P800 34936;
// A declaração da viriável "defaultDiacriticsRemovalap" foi transferida para o arquivo resource.aspx,
// pois o gulp estava transforlandos os códigos / expressões nas próprias letras, causando um bug

// http://stackoverflow.com/questions/990904/javascript-remove-accents-in-strings
var diacriticsMap = {};
for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters.split("");
    for (var j = 0; j < letters.length; j++) {
        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
}

// "what?" version ... http://jsperf.com/diacritics/12
function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return diacriticsMap[a] || a;
    });
}

function cryo_translateChars(s) {
    return removeDiacritics(s).replace(/[^\w\s]/gi, '');
}

function cryo_searchConfirmationNumber() {
    var $img = $(".box-confimation-number .captcha-img");
    var $btn = $(".box-confimation-number .btn-confirmation-search");
    var $codflowexecute = $(".box-confimation-number .input-confirmation-codflowexecute");
    var $confirmation = $(".box-confimation-number .input-confirmation-number");
    var $captcha = $(".box-confimation-number .input-confirmation-captcha");
    var $loading = $(".box-confimation-number .search-loading");
    var $msgnotfound = $(".box-confimation-number .error-notfound");
    var $msgcaptcha = $(".box-confimation-number .error-captcha");
    var $from = $("#From");

    $codflowexecute.width("20%");
    $confirmation.width("20%");
    $captcha.width("20%");
    $img.width("10%");

    $codflowexecute.add($captcha).add($confirmation).keypress(function (event) {
        if (event.which == 13) {
            $btn.trigger("click");
            return false;
        }
    });

    $(".box-confimation-number .input-confirmation-codflowexecute").focus(function () {
        $(this).removeClass("input-error");
    });
    $(".box-confimation-number .input-confirmation-number").focus(function () {
        $(this).removeClass("input-error");
    });

    function resetForm() {
        reloadImg();
        $captcha.val("");
    }

    function reloadImg() {
        $img.attr("src", URL_ROOT + "workbase/wcaptcha.aspx?" + (new Date()).getTime());
        $captcha.val("");
    }

    $img.click(function () {
        reloadImg();
    });

    reloadImg();

    $btn.click(function () {
        $btn.attr("disabled", true);

        $loading.show();
        $msgnotfound.hide();
        $msgcaptcha.hide();

        $codflowexecute.removeClass("input-error");
        $confirmation.removeClass("input-error");
        $captcha.removeClass("input-error");

        if ($codflowexecute.val() == "") {
            $codflowexecute.addClass("input-error");
        }
        if ($confirmation.val() == "") {
            $confirmation.addClass("input-error");
        }
        if ($captcha.val() == "") {
            $captcha.addClass("input-error");
        }

        if ($codflowexecute.val() != "" && $confirmation.val() != "" && $captcha.val() != "") {
            $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/confirmationnumber.aspx?e=" + $codflowexecute.val() + "&n=" + $confirmation.val() + "&ct=" + $captcha.val() + "&c=" + $from.val())
                .done(function (doc) {
                    if (doc.success != null) {
                        var url = doc.success;
                        resetForm();
                        if (disableInterfaceMobileV3 || !clientIsMobile) {
                            cryo_pop(url);
                        } else {
                            app.navigation.goTo(url);
                        }
                    } else if (doc.error != null && doc.error == "CAPTCHA") {
                        bsml.alert($msgcaptcha.text());
                        reloadImg();
                    } else {
                        bsml.alert($msgnotfound.text());
                        resetForm();
                    }
                }).fail(function (a, b, c) {
                    bsml.alert($msgnotfound.text());
                    resetForm();
                }).always(function () {
                    $loading.hide();
                    $btn.removeAttr("disabled");
                });
        } else {
            $loading.hide();
            $btn.removeAttr("disabled");
        }
    });
}

function cryo_alertAjaxError(jqXHR, textStatus, errorThrown) {
    var errorMessage = '';

    if (jqXHR.status != 200) {
        if (jqXHR.responseJSON) {
            if (jqXHR.responseJSON.friendlyMessage) {
                errorMessage += jqXHR.responseJSON.friendlyMessage;
            }
            if (jqXHR.responseJSON.logCode) {
                errorMessage += '\n' + mlLblErrorCode + ': ' + jqXHR.responseJSON.logCode;
            }
        } else if (jqXHR.statusText) {
            errorMessage += jqXHR.statusText;
        } else if (jqXHR.responseText) {
            errorMessage += jqXHR.responseText;
        }
    } else {
        if (textStatus) {
            errorMessage += textStatus;
        }
        if (errorThrown) {
            errorMessage += ' - ' + errorThrown;
        }

        errorMessage = mlMsgAjaxError.replace(/\{\{errorcode\}\}/gi, errorMessage);
    }

    bsml.alert(errorMessage);
}

function cryo_UnderlineAccessKey(selector, onlyTitle) {
    var defaultSelector = 'button[accesskey]';

    function shortcutKeyByBrowser() {
        var shortcutKey = 'Alt + ';

        if (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1) {
            shortcutKey = 'Control + Alt + ';
        } else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            shortcutKey = 'Alt + Shift + ';
        }

        return shortcutKey;
    }

    function underlineAccessKey(i, o) {
        if ($(o).html().indexOf('<u>') > -1) return;

        if ($(o).attr('title') === undefined) {
            $(o).attr('title', shortcutKeyByBrowser() + $(o).attr('accesskey').toUpperCase());
        }

        var accesskeyIndex = cryo_translateChars($(o).html()).toLowerCase().indexOf($(o).attr('accesskey').toLowerCase());

        if (accesskeyIndex == -1 || onlyTitle === true) return;

        var label, prefix, ak, suffix;
        label = $(o).html();
        prefix = label.substr(0, accesskeyIndex);
        ak = label.substr(accesskeyIndex, 1);
        suffix = label.substr(accesskeyIndex + 1);
        label = prefix + '<u>' + ak + '</u>' + suffix;

        $(o).html(label);
    }

    if (selector !== undefined) {
        $(selector).find(defaultSelector).each(underlineAccessKey);
    } else {
        $(defaultSelector).each(underlineAccessKey);
    }
}